import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/cronjobs",
		component: lazy(() => import("./AdminCronDashboardPage"))
	}
]);
